import { Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageHeaderComponent from "../common/components/pageHeader";
import { CustomButton } from "../common/components/customButton";
import { pageRefresh } from "../../utils/globalMethods";
import { connect } from "react-redux";
import { mapStateToProps } from "../../redux/reducers";
import { refreshKey } from "../../redux/actionTypes/administration";
import { useNavigate } from "react-router-dom";
import { PropTypes } from "prop-types";
import * as actionTypes from "../../redux/actionTypes/csaSignup";
import { Tab, Tabs } from "react-bootstrap";
import CsaSignupStatusList from "./CsaSignupStatusList";
import CsaSignupStatusHistoryList from "./CsaSignupStatusHistoryList";




const CSASignupStatusTab = (props) => {

  const navigate = useNavigate();

  const [csaSignupStatusTotal, setcsaSignupStatusTotal] = useState(0);

  useEffect(() => {
    const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
    if(props?.allowedRoles) {
      const checkRole = props?.allowedRoles.find((role) => userRole?.Role?.includes(role));
      if(!checkRole) {
        navigate('/dtahip');
        return;
      }
    }
  }, []);


     return(
    <Grid className="container-block" rowSpacing={2}> 
        <Grid container paddingBottom={2}>
            <Grid item xs={12} md={6}>
                <PageHeaderComponent 
                    title = {"CSA SIGNUP STATUS"}
                    // showSubtitle = {true}
                    // subtitle = {"Total Records"}
                    // count = {csaSignupStatusTotal}
                />
            </Grid>
            <Grid item xs={12} md={6} sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <CustomButton variant="outlined" startIcon={<i className="fa fa-refresh" aria-hidden="true"></i>} onClick={()=>{
                      //  setSearch("");
                      //  setExpand(false);
                      //  setTableSort({"submittedDate":"DESC"});
                      //  props.refreshKey();
                      //  resetSize();
                      //  setShowLoader(true)
                       pageRefresh();
                      }}
                       >
                    Refresh
                    </CustomButton>
                </Stack>
            </Grid>
        </Grid>
                <Tabs className="vendor-info-tabs"
                    id="controlled-tab"
                    style={{ background: "#fff" }}
                >
                    <Tab eventKey="list" title={<div className="tab-header"><span className="m-l-5">List</span></div>}>
                        <CsaSignupStatusList 
                          setcsaSignupStatusTotal={setcsaSignupStatusTotal} 
                          csaSignupStatusTotal={csaSignupStatusTotal}
                          // setSearch= {setSearch}
                          // search={search}
                          // setTableSort={setTableSort}
                          // tableSort={tableSort}
                          // setShowLoader={setShowLoader}
                          // showLoader={showLoader}
                          // expand={expand}
                          // setExpand={setExpand}

                        />

                    </Tab>
                    <Tab eventKey={"history"} title={<div className="tab-header"><span className="m-l-5">History</span></div>}>
                        <CsaSignupStatusHistoryList />
                    </Tab>
                </Tabs>

    </Grid>

  );

};

CSASignupStatusTab .propTypes = {
  refreshKey: PropTypes.func.isRequired,
  getCsaSignupStatusList: PropTypes.func.isRequired,
  csaSignup: PropTypes.object.isRequired,
  exportCsaSignupStatus: PropTypes.func,
  allowedRoles: PropTypes.array,
  userAuth : PropTypes.object,

}
function mapDispatchToProps(dispatch) {
  return {
    refreshKey: () => dispatch(refreshKey()),
    getCsaSignupStatusList: (payload) => dispatch(actionTypes.getCsaSignupStatusList(payload)),

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CSASignupStatusTab);
